import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const isDevelopmentEnv = process.env.NODE_ENV === 'development';
/**
 * The following is a hack necessary for cypress tests to execute else they fail due to
 * vaporio not being available when this file is imported by other files.
 *
 * Ideally it would be more like
 * declare const vaporio: IVaporio;
 *
 * const supportedLngs = vaporio?.i18n ? ['en', 'es'] : ['en']
 */
const initialSupportedLanguages = [ 'en' ];
const vaporWindow = window as any;

const supportedLngs = initialSupportedLanguages;

if (vaporWindow?.vaporio?.i18n) {
	 // MFUI doesn't support additional languages at this time
}
/**
  * End hack for cypress tests to execute
  */

// eslint-disable-next-line import/no-named-as-default-member
i18n
	.use(Backend)
	.use(LanguageDetector) // MFUI doesn't support additional languages at this time
	.use(initReactI18next)
	.init({
		backend: {
			addPath: '/translations/add/{{lng}}/{{ns}}',
			loadPath: '/translations/{{lng}}/{{ns}}.json',
			parsePayload: (namespace, key) => {
				// missing keys will be created following the format of our existing import { useTranslation } from 'react-i18next'; constants file
				return { [ key.toUpperCase().replace(/ /g, '_') ]: key };
			}
		},
		contextSeparator: '__',
		debug: isDevelopmentEnv,
		defaultNS: 'Common',
		fallbackLng: 'en',
		fallbackNS: 'Common',
		initImmediate: false,
		interpolation: { escapeValue: false },
		load: 'languageOnly',
		lowerCaseLng: true,
		ns: [ 'Components', 'Common' ],
		partialBundledLanguages: true,
		pluralSeparator: '__',
		saveMissing: isDevelopmentEnv,
		saveMissingTo: 'all',
		supportedLngs
	}).catch((e) => {
		throw new Error(`error loading i18next ${e}`);
	});

export default i18n;
